
import { SET_HISTORICAL_LOADS_BY_MC } from '../actionTypes'

const initialState = []

export default (state=initialState,  action) => {

    switch(action.type) {
    case SET_HISTORICAL_LOADS_BY_MC:
        return action.loads
    default:
        return state
    }
    
}